import React from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { t } from "adapters/i18n";

interface ForageCycleManagementFooterProps {
  countLabel: string;
  disabled: boolean;
  saving: boolean;
  onSave: () => void;
}

function ForageCycleManagementFooter({
  countLabel,
  disabled,
  saving,
  onSave,
}: ForageCycleManagementFooterProps) {
  return (
    <footer className="forage-cycle-management__footer">
      <Typography className="forage-cycle-management__footer-count">
        {countLabel}
      </Typography>
      <Button
        color="primary"
        variant="contained"
        disabled={disabled}
        onClick={onSave}
        className="forage-cycle-management__save-action"
      >
        {saving ? (
          <CircularProgress size={16} aria-label={t("forageCycle:cycle-saving")} />
        ) : (
          t("forageCycle:cycle-save")
        )}
      </Button>
    </footer>
  );
}

export default ForageCycleManagementFooter;
